export default "https://cdn-static.gokick.com/assets/9175df2ab050434674d4a27e4dae3ab0ebb22d80/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";